// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vue2TouchEvents from 'vue2-touch-events'
import App from '@/App'
import router from '@/router'
import BootstrapVue from 'bootstrap-vue'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import store from '@/store/store';
// import DoubleClick from 'vue-doubleclick';
import VueAnalytics from 'vue-analytics';
import VueMq from 'vue-mq';
import vf from 'vue-forage';

const checkIfProd = process.env.NODE_ENV === 'production';

// console.log('process.env.NODE_ENV: ', process.env.NODE_ENV);
// console.log('checkIfProd: ', checkIfProd);

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)

Vue.config.productionTip = false

Vue.use(BootstrapVue);

Vue.use(Vue2TouchEvents);

Vue.use(VueMq, {
	breakpoints: {
		mobile: 450,
		tablet: 900,
		laptop: 1250,
		desktop: Infinity
	}
});

// Vue.use(vf);

/*
REMEMBER TO DISABLE DEBUG AND ENABLE SENDHITTASK FOR PROD
*/
Vue.use(VueAnalytics, {
	id: 'UA-57696902-6', // CMGO GA ACCOUNT
	// id: 'UA-12007193-41', // CMG GA ACCOUNT
	// id: ['UA-57696902-6','UA-12007193-41'], // COMBINED CMGO AND CMG ACCOUNT CALLS
	router,
	autoTracking: {
		screenview: false
	},
	debug: {
		enabled: false,
		trace: false,
		sendHitTask: checkIfProd
	}
});


 /** CONFIGURATION START **/
window._sf_async_config={};
window._sf_async_config.uid = 31585;
window._sf_async_config.domain = 'dayton.com';
window._sf_async_config.useCanonical = true;
// _sf_async_config.sections = 'section1,section2 ';
// _sf_async_config.authors = 'author1,author2 ';
/** CONFIGURATION END **/

window.removeChartbeat = function() {
	if(checkIfProd) {
		if(document.getElementById('cb_script')) {
			var cb_script = document.getElementById('cb_script');
			cb_script.parentNode.removeChild(cb_script);
		}
	}
}
window.updateChartbeat = function(page_title, path_name) {
	if(checkIfProd) {
		if(typeof window.pSUPERFLY == 'undefined') {
			setTimeout(function() {
				window.updateChartbeat(page_title, path_name);
			}, 3000);
		}
		else {
			window.pSUPERFLY.virtualPage({
				path: path_name,
				title: page_title
			});
		}
	}
}
window.loadChartbeat = function() {
	if(checkIfProd) {
		window._sf_endpt = (new Date()).getTime();
	
		var e = document.createElement('script');
		e.setAttribute('language', 'javascript');
		e.setAttribute('type', 'text/javascript');
		e.setAttribute('id', 'cb_script');
		e.setAttribute('src', '//static.chartbeat.com/js/chartbeat_video.js');
		document.body.appendChild(e);
	}
	
}
if(checkIfProd) {
	var oldonload = window.onload;
	window.onload = (typeof window.onload != 'function') ?
		loadChartbeat : function() {
			oldonload();
			loadChartbeat();
		};
}

/*
COMMENTING OUT AD UNIT SETUP
*/
/*let mappings = {

	block: [
		{ window: [0, 0], sizes: [[300, 250]] }, // MOBILE
		{ window: [420, 0], sizes: [[300, 250]] }, // TABLET
		{ window: [480, 0], sizes: [[300, 250]] }, // TABLET
		{ window: [768, 0], sizes: [[300, 250]] }, // LAPTOP
		{ window: [1024, 0], sizes: [[300, 250]] }, // DESKTOP
		{ window: [1280, 0], sizes: [[300, 250]] }, // DESKTOP BIG
	],

	rectangle: [
        { window: [0, 0], sizes: [[320, 50]] }, // MOBILE
		{ window: [420, 0], sizes: [[320, 50]] }, // TABLET
		{ window: [480, 0], sizes: [[320, 50]] }, // TABLET
		{ window: [768, 0], sizes: [[320, 50]] }, // LAPTOP
		{ window: [1024, 0], sizes: [[320, 50]] }, // DESKTOP
		{ window: [1280, 0], sizes: [[320, 50]] }, // DESKTOP BIG
    ],

	banner: [
		{ window: [0, 0], sizes: [[320, 50]] }, // MOBILE
		{ window: [420, 0], sizes: [[320, 50]] }, // TABLET
		{ window: [480, 0], sizes: [[320, 50]] }, // TABLET
		{ window: [768, 0], sizes: [[728, 90]] }, // LAPTOP
		{ window: [1024, 0], sizes: [[728, 90]] }, // DESKTOP
		{ window: [1280, 0], sizes: [[728, 90]] }, // DESKTOP BIG
	]
};

let sizes = {
	block: [[300, 250]]
}

Vue.use(DoubleClick, {
    id: '12523293',
    mappings,
    sizes
});*/
/*
END AD UNIT SETUP
*/

/* eslint-disable no-new */
const root = new Vue({
  el: '#app',
  router,
  template: '<App/>',
  data: {
  	store: store,
  	state: {
  		env: process.env.NODE_ENV
  	}
  },
  components: { 
  	App 
  }
})


// WEBPACK FOOTER //
// ./src/main.js